import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { PortalLogo } from '../images';

interface Props {
  subText?: string;
}

export const WeavePortalLogo = ({ subText = 'Portal' }: Props) => {
  return (
    <picture
      css={css`
        margin: ${theme.spacing(2)} auto;
        position: relative;
        display: inline-block;
        &::after {
          content: '${subText.toUpperCase()}';
          color: ${theme.colors.primary50};
          font-weight: bold;
          font-size: ${theme.fontSize(12)};
          position: absolute;
          bottom: 0;
          right: 0;
        }
      `}
    >
      <PortalLogo title={`weave ${subText.toLowerCase()} logo`} />
    </picture>
  );
};
